module.exports = "/_next/static/images/ntuc-card-front-af9ee890349e81e160039fa845e47f4a.png";